import { IColumnVisibilityModel } from "../../api/concierges/preferences";

export const syncRevisedEcoeDelayedReasonVisibility = (
  model: IColumnVisibilityModel,
  previousModel?: IColumnVisibilityModel
): IColumnVisibilityModel => {
  const hasRevised = Object.prototype.hasOwnProperty.call(model, "revisedEcoe");
  const hasDelayed = Object.prototype.hasOwnProperty.call(model, "delayedReason");

  if (!hasRevised && !hasDelayed) {
    return model;
  }

  if (!previousModel) {
    return model;
  }

  const revisedVisible = model.revisedEcoe !== false;
  const delayedVisible = model.delayedReason !== false;
  const previousRevisedVisible = previousModel.revisedEcoe !== false;
  const previousDelayedVisible = previousModel.delayedReason !== false;

  const revisedSelected = !previousRevisedVisible && revisedVisible;
  const delayedSelected = !previousDelayedVisible && delayedVisible;
  const revisedUnselected = previousRevisedVisible && !revisedVisible;
  const delayedUnselected = previousDelayedVisible && !delayedVisible;

  if (revisedSelected || delayedSelected) {
    return {
      ...model,
      revisedEcoe: true,
      delayedReason: true,
    };
  }

  if (revisedUnselected || delayedUnselected) {
    return {
      ...model,
      revisedEcoe: false,
      delayedReason: false,
    };
  }

  return model;
};